<div class="container">

<div #amplifyContainer >
  <amplify-authenticator *ngIf="showAmplifyAuthenticator" [signUpAttributes]="[
  'email',
  'family_name',
  'given_name',
  'nickname',
  'updated_at'
  ]"
  [services]="services"
  >
    <ng-template
      amplifySlot="authenticated"
      let-user="REDWOOD_USER()"
    >
      <div class="amplifyBorders">
        <h3 [hidden]="!userDisplayName">Welkom {{userDisplayName}} !</h3>
        <p class="loginInfo"> U bent aangemeld via {{destination_pool}}</p>
        <ul *ngIf="!isMapUser" style="list-style: none;">
          <li [hidden]="!userDisplayName">
            <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" style="font-weight: normal;" (click)="profile()">Profiel</button>
          </li>
          <li [hidden]="!isTypeOfAdmin">
            <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" style="font-weight: normal;" (click)="addUser()">Gebruiker toevoegen</button>
          </li>
          <li [hidden]="isTypeOfAdmin">
            <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" style="font-weight: normal;" (click)="manageSchools()">Beheer scholen</button>
          </li>
          <li>
            <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" style="font-weight: normal;" (click)="signOut()">Uitloggen</button>
          </li>
          <!--
          <li *ngIf="!isProd">
            <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" style="font-weight: normal;" (click)="organizations()">Organizaties</button>
          </li>
          <li *ngIf="!isProd">
            <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" style="font-weight: normal;" (click)="roles()">Beheer rollen</button>
          </li>-->
        </ul>
      </div>

    </ng-template>
    <ng-template
      amplifySlot="sign-up-form-fields"
    let-validationErrors="validationErrors"
    >
    <!-- Re-use default `Authenticator.SignUp.FormFields` -->
    <amplify-sign-up-form-fields></amplify-sign-up-form-fields>
    <input type="hidden" name="custom:captchaHidden" id="captchaHidden" >
    <input type="hidden" name="custom:captchaRest" id="captchaRest" >
    <input class="thepot" type="text" name="custom:honeyPot" value=""/>
</ng-template>

</amplify-authenticator>


</div>
